import React from "react";
import { Box } from "@mui/material";
import DetailedRegister from "./DetailedRegister";
import DetailedRegisterMain from "./NewDetailedRegister/detailed_register_main"
import { getSession } from "../../auth"
import ContentUnavailable from "../ContentUnavailable"
import BarChartIcon from "@mui/icons-material/BarChart"
import { hasActivePlatforms } from "../../utils/utils"
import { useMenu } from "../../contexts/MenuContext"

const ReportGrid = () => {
    const { configurableUrls } = useMenu()

    if (! hasActivePlatforms(getSession().profile?.enterprise?.platforms || {})) {
        return (
            <ContentUnavailable
                icon={<BarChartIcon />}
                title="Recurso indisponível para sua conta."
                description={
                    <a href={configurableUrls?.atendimento ? configurableUrls.atendimento : "https://solucoes.instant.com.br/kwik/"} target="_blank" rel="noopener noreferrer">
                        Para mais informações sobre o módulo de atendimento, clique aqui.
                    </a>
                }
            />
        )
    }

    return (
        <DetailedRegisterMain />
    );
}

export default ReportGrid;
